"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PickerPlugin_1 = require("./PickerPlugin");
exports.PickerPlugin = PickerPlugin_1.default;
//# sourceMappingURL=index.js.map